import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Switch } from "../ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { API_URL, todayLuanda } from "../../lib/utils";

const KINDS = [["absence", "Falta"], ["late", "Atraso"], ["present", "Presença (esqueceu o check-in)"]];
const blank = (userId = "") => ({ user_id: userId, date: todayLuanda(), kind: "absence", late_minutes: 15, justified: false, note: "" });

export const AttendanceManualDialog = ({ open, onOpenChange, employees, headers, onSaved, preset }) => {
  const [form, setForm] = useState(blank());
  const [saving, setSaving] = useState(false);
  const value = form;
  const today = todayLuanda();

  useEffect(() => { if (open) setForm(blank(preset?.user_id || "")); }, [open, preset]);

  const submit = async (e) => {
    e.preventDefault();
    if (!value.user_id) { toast.error("Escolha o funcionário"); return; }
    setSaving(true);
    try {
      await axios.post(`${API_URL}/hr/attendance/manual`, { ...value, late_minutes: Number(value.late_minutes) || 0 }, { headers, withCredentials: true });
      toast.success("Registo guardado");
      onOpenChange(false); onSaved?.();
    } catch (err) { toast.error(err.response?.data?.detail || "Erro ao guardar"); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="attendance-manual-dialog">
        <DialogHeader>
          <DialogTitle>Registar manualmente</DialogTitle>
          <DialogDescription>Falta, atraso ou presença de um funcionário num dia. Registos justificados não descontam no salário.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="space-y-1"><Label className="text-xs">Funcionário</Label>
            <Select value={value.user_id} onValueChange={(v) => setForm({ ...form, user_id: v })}>
              <SelectTrigger data-testid="manual-employee-select"><SelectValue placeholder="Escolher…" /></SelectTrigger>
              <SelectContent>{employees.map((e) => <SelectItem key={e.user_id} value={e.user_id}>{e.name}</SelectItem>)}</SelectContent>
            </Select></div>
          <div className="grid grid-cols-2 gap-2">
            <div className="space-y-1"><Label className="text-xs">Data</Label><Input type="date" required value={value.date} max={today} onChange={(e) => setForm({ ...form, date: e.target.value })} data-testid="manual-date-input" /></div>
            <div className="space-y-1"><Label className="text-xs">Tipo</Label>
              <Select value={value.kind} onValueChange={(v) => setForm({ ...form, kind: v })}>
                <SelectTrigger data-testid="manual-kind-select"><SelectValue /></SelectTrigger>
                <SelectContent>{KINDS.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
              </Select></div>
          </div>
          {value.kind === "late" && <div className="space-y-1"><Label className="text-xs">Minutos de atraso</Label><Input type="number" min={1} max={720} value={value.late_minutes} onChange={(e) => setForm({ ...form, late_minutes: e.target.value })} data-testid="manual-late-minutes-input" /></div>}
          <div className="space-y-1"><Label className="text-xs">Nota / justificação</Label><Input value={value.note} onChange={(e) => setForm({ ...form, note: e.target.value })} placeholder="Ex.: consulta médica com comprovativo" data-testid="manual-note-input" /></div>
          {value.kind !== "present" && (
            <div className="flex items-center justify-between rounded-lg border p-2.5">
              <span className="text-sm">Justificado (não desconta)</span>
              <Switch checked={value.justified} onCheckedChange={(v) => setForm({ ...form, justified: v })} data-testid="manual-justified-switch" />
            </div>
          )}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
            <Button type="submit" disabled={saving} data-testid="manual-save-btn">{saving ? "A guardar…" : "Guardar"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
